import React from 'react';

/**
 * Global footer shown on every page (authenticated and public).
 * Copy is fixed; do not personalise per-user.
 */
export default function AppFooter() {
  return (
    <footer
      className="w-full border-t border-slate-200 dark:border-slate-800 bg-white/70 dark:bg-slate-950/70 backdrop-blur-sm py-3 px-4 mt-8"
      data-testid="app-footer"
    >
      <div className="max-w-7xl mx-auto text-center text-[11px] sm:text-xs text-slate-500 dark:text-slate-400">
        <span className="font-medium text-slate-600 dark:text-slate-300">
          Powered by EYB Consulting Pty Ltd
        </span>
        <span className="mx-2 text-slate-300 dark:text-slate-600">|</span>
        <span className="italic">Clarity and Control, built for your business</span>
      </div>
    </footer>
  );
}
